import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-new-button-container" }
const _hoisted_2 = { class: "position-relative" }

import ButtonBase from "@/components/custom/ButtonBase.vue";

import buttonProps from "@/components/custom/ButtonFilterSelect/ButtonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonFixed',
  props: {...buttonProps},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ButtonBase, _mergeProps(props, {
        width: "100%",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
      }), null, 16)
    ])
  ]))
}
}

})